import script from "./WalletPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./WalletPage.vue?vue&type=script&setup=true&lang=ts"

import "./WalletPage.vue?vue&type=style&index=0&id=ce59f1f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce59f1f6"]])

export default __exports__